import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Icon } from 'components';

import styles from './AISuggestion.module.scss';

interface AISuggestionProps {
  onIconClick: () => void;
}

export const AISuggestion = memo(({ onIconClick }: AISuggestionProps) => {
  const [showSuggestion, setShowSuggestion] = useState(true);
  const [t] = useTranslation('candidate.profile');

  useEffect(() => {
    setShowSuggestion(true);
  }, []);

  return (
    <>
      {showSuggestion && (
        <section className={styles['suggestion-container']}>
          <section className={styles['inner-box']}>
            <div className={styles['text-container']}>
              <Icon
                iconName="icon_magic-wand"
                size="small"
                className={styles['magic-icon']}
              />
              <p className={styles.text}>{t('ai-suggestion.text1')}</p>
              <div
                className={styles['suggestion-content']}
                onClick={onIconClick}
              >
                <p className={styles['suggestion-text']}>
                  {t('ai-suggestion.text2')}
                </p>
                <Icon iconName="arrow-button-right" size="xsmallplus" />
              </div>
            </div>
            <div className={styles['close-button']}>
              <div onClick={() => setShowSuggestion(false)}>
                <Icon iconName="icon_close" className={styles.Icon} />
              </div>
            </div>
          </section>
        </section>
      )}
    </>
  );
});

AISuggestion.displayName = 'AISuggestion';
